
import customParseFormat from "dayjs/plugin/customParseFormat";

import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Dialog, Autocomplete, TextField } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ExcelJS from "exceljs";
import * as XLSX from "xlsx";
import dayjs from "dayjs";

import { FileUploader } from "react-drag-drop-files";
import BulkUploadPreview from "../../CreatePolicy/BulkUploadPreview";
import { Transition } from "../../../../UiComponents/Transition/Transition";
import { ToastError, ToastSuccess } from "../../../../UiComponents/Toaster/Toast";
import {
  PostBulkUploadExcelFile,
  UpdateBulkUploadExcelFileTimestamp,
  PostCreatePolicy,
  GetCompanyLogin,
  GetFuelType,
  GetVehicleMake,
  ImportAndUpdateBulkUploadedPolicies,
  CreateBulkPolicies,
} from "../../../../Service/_index";
dayjs.extend(customParseFormat);
const BULK_COMPANY_OPTIONS = [
  { label: "Reliance", value: "reliance" },
  { label: "National", value: "national" },
  { label: "United", value: "UNITED INDIA GIC LTD" },
];

const DEFAULT_PAYMENT_MODE = "Online";
const DEFAULT_POLICY_PORTAL = "Company Portal";

// Company-specific mandatory fields
const COMPANY_REQUIRED_FIELDS = {
  reliance: [
    "policyNumber",
    "customerName",
    // "make",
    "fuelType",
    "model",
    "registrationNumber",
    "registrationYear",
    "odDisc",
    "issueDate",
    "odPremium",
    "seatingCapacity",
    "addOnPremium",
    "loginIdFull",
    "tpPremium",
    "totalPremium",
    "cc",
  ],
  united: [
    "policyNumber",
    "registrationYear",
    // "make",
    "customerName",
    "mobileNumber",
    "model",
    "odPremium",
    "tpPremium",
    "totalPremium",
    "gvw",
    "loginIdFull",
    "issueDate"
  ],
  national: [
    "customerName",
    "policyNumber",
    "registrationNumber",
    // "make",
    "model",
    "seatingCapacity",
    "fuelType",
    "registrationYear",
    "cc",
    "odPremium",
    "tpPremium",
    "premium",
    "pospCode",
    "issueDate"
  ],
};

// Normalize selected company to the key used in COMPANY_REQUIRED_FIELDS
// Keeps the display label (e.g. "UNITED INDIA GIC LTD") unchanged while mapping to internal key
const getCompanyRequiredFieldsKey = (selectedCompany) => {
  if (!selectedCompany) return "";
  const raw = (selectedCompany.value || selectedCompany.label || "")
    .toString()
    .toLowerCase();
  if (raw.includes("united india")) return "united"; // maps "UNITED INDIA GIC LTD" value to internal key
  if (raw.includes("reliance")) return "reliance";
  if (raw.includes("national")) return "national";
  return raw;
};

const BULK_FIELD_MAPPINGS = [
  {
    label: "Policy Number",
    formKey: "policyNumber",
    keys: [
      "policy_number",
      "policy_no",
      "policyno",
      "policy_num",
      "policynum",
      "policynumber",
    ],
  },
  {
    label: "Customer Name",
    formKey: "customerName",
    keys: [
      "customername",
      "customer_name",
      "customer",
      "customerfull",
      "clientname",
      "client_name",
    ],
  },
  {
    label: "Make",
    formKey: "make",
    keys: ["make"],
  },
  {
    label: "Model",
    formKey: "model",
    keys: ["model"],
  },
  {
    label: "Fuel Type",
    formKey: "fuelType",
    keys: ["fueltype", "fuel_type"],
  },
  {
    label: "Vehicle No",
    formKey: "registrationNumber",
    keys: [
      "vechileno",
      "vehicleno",
      "vehicle_no",
      "vehiclenumber",
      "vehicle_number",
      "registration",
      "registration_no",
      "registration_number",
      "vehicleregistrationnumber",
      "vehicle_registration_number",
    ],
  },
  {
    label: "Year Of Manufacture",
    formKey: "registrationYear",
    keys: [
      "yearofmanufacture",
      "year_of_manufacture",
      "year of manufacture",
      "manufacturingyear",
      "manufacturing_year",
      "manufacturing year",
      "registration_year",
      "registrationyear",
      "registration year",
      "year",
      "mfg_year",
      "mfg year",
      "manufacture_year",
      "manufacture year",
    ],
  },
  {
    label: "OD Discount",
    formKey: "odDisc",
    keys: [
      "oddiscount",
      "od_discount",
      "ODDiscount",
      "od_disc",
      "od_discou",
      "oddiscountpercent",
    ],
  },
  {
    label: "Prop Date",
    formKey: "issueDate",
    keys: [
      "propdate",
      "prop_date",
      "prop date",
      "issue_date",
      "PropDate",
      "issue date",
      "issuedate",
      "policystartdate",
      "policy_start_date",
      "policy start date",
      "transationdate",
      "transaction_date",
      "transaction date",
      "policy_date",
      "policy date",
      "date_of_issue",
      "date of issue",
      "dateofissue",
      "Entry Date",
      "Policy Effective Date"
    ],
    transform: (value) => {
      if (value === undefined || value === null || value === "") return null;
      if (value instanceof Date) return value;
      if (typeof value === "number") {
        // Excel serial date number
        const excelEpoch = new Date(Math.round((value - 25569) * 86400 * 1000));
        if (!Number.isNaN(excelEpoch.getTime())) {
          return excelEpoch;
        }
      }
      // Handle common Excel-exported date string formats
      const str = value.toString().trim();
      const formats = [
        // Date only
        "DD/MM/YYYY",
        "D/M/YYYY",
        "DD-MM-YYYY",
        "D-M-YYYY",
        "YYYY-MM-DD",
        "YYYY/MM/DD",
        "DD-MMM-YYYY",
        "D-MMM-YYYY",
        "DD-MMM-YY",
        "D-MMM-YY",
        "MMM D, YYYY",
        "D MMM YYYY",
        // Date with time
        "DD/MM/YYYY HH:mm:ss",
        "D/M/YYYY HH:mm:ss",
        "DD-MM-YYYY HH:mm:ss",
        "D-M-YYYY HH:mm:ss",
        "YYYY-MM-DD HH:mm:ss",
        "YYYY/MM/DD HH:mm:ss",
        // Date with time (no leading zeros)
        "DD/MM/YYYY H:m:s",
        "DD-MM-YYYY H:m:s",
        "D-M-YYYY H:m:s",
      ];
      // Try strict parsing against known formats first
      for (const fmt of formats) {
        const d = dayjs(str, fmt, true);
        if (d.isValid()) return d.toDate();
      }
      // Fallback to lenient parsing
      const parsed = dayjs(str);
      return parsed.isValid() ? parsed.toDate() : null;
    },
  },
  {
    label: "OD Net Premium",
    formKey: "odPremium",
    keys: [
      "odnetpremium",
      "od_net_premium",
      "odpremium",
      "od_premium",
      "od_premiu",
      "netodpremium",
      "net_od_premium",
      "odpremiumexcludinggst",
      "od_premium_excluding_gst",
      "OD premium (Excluding GST",
      "OD premium (Excluding GST)"
    ],
  },
  {
    label: "TP Premium",
    formKey: "tpPremium",
    keys: [
      "tppremium",
      "tp_premium",
      "tp_premiu",
      "tppremiumexcludinggst",
      "tp_premium_excluding_gst",
      "TP premium (Excluding GST)"
    ],
  },
  {
    label: "Gross Premium",
    formKey: "totalPremium",
    keys: [
      "grosspremium",
      "gross_premium",
      "gross premium",
      "total_premium",
      "totalpremium",
      "total premium",
      "premium",
      "premium_amount",
      "premium amount",
      "premium_total",
      "premium total",
      // "netpremium",
      // "net_premium",
      // "net premium",
    ],
  },
  {
    label: "CC",
    formKey: "cc",
    keys: ["cc", "Engine Cubic Capacity", "engine_cubic_capacity"],
  },
  {
    label: "Seating Capacity",
    formKey: "seatingCapacity",
    keys: [
      "seatingcapacity",
      "seating_capacity",
      "seatingcap",
      "seating_ca",
      "seating",
    ],
  },
  {
    label: "Add-On Premium",
    formKey: "addOnPremium",
    keys: [
      "addonpremium",
      "add_on_premium",
      "addon_premium",
      "add_on",
      "add_on_pre",
      "add_onpremium",
      "addon_pre",
    ],
  },
  {
    label: "User ID",
    formKey: "loginIdFull",
    keys: ["userid", "user_id", "user_id"],
  },
  {
    label: "Mobile No",
    formKey: "mobileNumber",
    keys: ["mobileno", "mobile_no", "mobile", "mobilenumber", "mobile_number"],
  },
  {
    label: "GVW",
    formKey: "gvw",
    keys: ["gvw"],
  },
  {
    label: "IDV",
    formKey: "idv",
    keys: ["idv"],
  },
  {
    label: "Premium",
    formKey: "premium",
    keys: ["Premium", "premium"],
  },
  {
    label: "POSP Code",
    formKey: "pospCode",
    keys: ["pospcode", "posp_code", "POSP Code"],
  }
];

const BulkUploadDialog = ({
  open,
  onClose,
  companyDetails = [],
  onSuccess,
  setOpenLoader,
  mode = "create",
  selectedBulkFileId = null,
  selectedBulkFileName = "",
  allowedPolicyNumbers = [],
  unmatchedPolicies = [],
}) => {
  const isCreateMode = mode === "create";
  const dialogTitle = isCreateMode
    ? "Bulk Upload Policies"
    : "Import and Update Policies";
  const [bulkCompany, setBulkCompany] = useState(null);
  const [bulkFileName, setBulkFileName] = useState("");
  const [bulkPreview, setBulkPreview] = useState([]);
  const [bulkResults, setBulkResults] = useState(null);
  const [bulkProcessing, setBulkProcessing] = useState(false);
  const [bulkFileNameError, setBulkFileNameError] = useState("");
  const [bulkFileObject, setBulkFileObject] = useState(null);
  const [companyLoginLookup, setCompanyLoginLookup] = useState({});
  const [fuelTypeLookup, setFuelTypeLookup] = useState({});
  const [vehicleMakeLookup, setVehicleMakeLookup] = useState({});
  const [importResults, setImportResults] = useState(null);
  const [invalidPolicyNumbers, setInvalidPolicyNumbers] = useState([]);
  const [userIdMismatchRows, setUserIdMismatchRows] = useState([]);
  const [vehicleFuelValidationErrors, setVehicleFuelValidationErrors] = useState([]);
  const [showAllUserIdErrors, setShowAllUserIdErrors] = useState(false);
  const [showAllInvalidPolicyErrors, setShowAllInvalidPolicyErrors] = useState(false);
  const [showAllVehicleFuelErrors, setShowAllVehicleFuelErrors] = useState(false);
  const [showAllBulkResultErrors, setShowAllBulkResultErrors] = useState(false);
  const [showAllImportResultErrors, setShowAllImportResultErrors] = useState(false);
  const [isParsingFile, setIsParsingFile] = useState(false);

  const normalizeHeader = (header) => {
    if (header === undefined || header === null) {
      return "";
    }
    if (typeof header === "object") {
      const values =
        typeof header.values === "function"
          ? header.values()
          : Array.isArray(header.values)
            ? header.values
            : Object.values(header).filter((val) => val !== undefined && val !== null);
      return normalizeHeader(values[0]);
    }
    return header
      .toString()
      .trim()
      .replace(/[\s]+/g, " ")
      .toLowerCase()
      .replace(/\s+/g, "_")
      .replace(/[^a-z0-9_]/g, "_");
  };

  const normalizeLoginIdentifier = (value) => {
    if (value === undefined || value === null) return "";
    return value
      .toString()
      .trim()
      .replace(/'/g, "")
      .toUpperCase();
  };

  const normalizePolicyNumberValue = (value) => {
    if (value === undefined || value === null) return "";
    // Remove leading apostrophe that Excel adds to prevent number formatting
    return value.toString().trim().replace(/'/g, "").toUpperCase();
  };

  const normalizeVehicleMakeOrFuelType = (value) => {
    if (!value) return "";

    let normalized = value
      .toString()
      .trim()
      // First normalize all whitespace to single spaces
      .replace(/\s+/g, " ")
      .toLowerCase()
      // Remove all punctuation (periods, commas, hyphens, etc.)
      .replace(/[.,\-_()]/g, " ")
      // Replace common abbreviations with full forms
      .replace(/\bpvt\b/g, "private")
      .replace(/\bltd\b/g, "limited")
      .replace(/\bco\b/g, "company")
      .replace(/\bmfg\b/g, "manufacturing")
      .replace(/\bcorp\b/g, "corporation")
      .replace(/\binc\b/g, "incorporated")
      // Remove multiple spaces again after replacements and trim
      .replace(/\s+/g, " ")
      .trim();

    return normalized;
  };

  const findBestMatch = (searchValue, lookupObject) => {
    if (!searchValue || !lookupObject || Object.keys(lookupObject).length === 0) {
      return null;
    }

    const normalizedSearch = normalizeVehicleMakeOrFuelType(searchValue);

    // Debug logging for HERO MOTOR
    const isHeroSearch = searchValue.toUpperCase().includes("HERO");
    // if (isHeroSearch) {
    //   console.log("=== Searching for HERO vehicle make ===", {
    //     original: `"${searchValue}"`,
    //     normalized: `"${normalizedSearch}"`,
    //     lookupKeys: Object.keys(lookupObject).filter(k => k.includes("hero"))
    //   });
    // }

    // Try exact match first (normalized)
    if (lookupObject[normalizedSearch]) {
      if (isHeroSearch) console.log("✓ Found exact match for HERO");
      return lookupObject[normalizedSearch];
    }

    // Try partial match - check if any database entry contains the search term or vice versa
    const keys = Object.keys(lookupObject);

    for (const key of keys) {
      const normalizedKey = normalizeVehicleMakeOrFuelType(key);

      // Check if normalized values match
      if (normalizedKey === normalizedSearch) {
        if (isHeroSearch) console.log("✓ Found normalized match for HERO:", key);
        return lookupObject[key];
      }

      // Check if one contains the other (for cases like "PIAGGIO" matching "PIAGGIO VEHICLES PRIVATE LIMITED")
      if (normalizedSearch.includes(normalizedKey) || normalizedKey.includes(normalizedSearch)) {
        // Prefer shorter matches (more specific)
        if (normalizedKey.length >= 3) { // Avoid matching very short strings
          if (isHeroSearch) console.log("✓ Found partial match for HERO:", key);
          return lookupObject[key];
        }
      }
    }

    // if (isHeroSearch) {
    //   console.log("✗ No match found for HERO MOTOR");
    // }
    return null;
  };

  const validateUserIdMatch = (records, selectedCompany = null) => {
    if (!records || !records.length) {
      setUserIdMismatchRows([]);
      return true;
    }
    // Use normalized company key ("united" for UNITED INDIA GIC LTD, "national" for National)
    const companyKey = getCompanyRequiredFieldsKey(selectedCompany);
    const isUnitedCompany = companyKey === "united";
    const isNationalCompany = companyKey === "national";

    const mismatchList = [];
    records.forEach((record) => {
      const extractedValues =
        record.__extracted ||
        (record && typeof record === "object" ? record : {});
      const loginIdValue = extractedValues?.loginIdFull || "";
      const pospCodeValue = extractedValues?.pospCode || "";

      // For National company, check POSP code instead of UserID
      if (isNationalCompany) {
        // Skip if POSP code is empty
        if (!pospCodeValue) {
          return;
        }

        // Validate POSP code
        const normalizedPospCode = normalizeLoginIdentifier(pospCodeValue);
        const matchedLogin = normalizedPospCode ? companyLoginLookup[normalizedPospCode] : null;

        // console.log(`Validating POSP code: "${pospCodeValue}" -> normalized: "${normalizedPospCode}" -> matched:`, matchedLogin ? 'YES' : 'NO');

        if (!matchedLogin) {
          mismatchList.push({
            row: record.__rowNumber || record.rowNumber || "-",
            loginId: pospCodeValue,
            error: `POSP Code not found in Company Login remarks`,
          });
        }
      } else {
        // For other companies (Reliance, United), check UserID
        // Skip validation if UserID is empty
        if (!loginIdValue) {
          return;
        }

        // Only validate if UserID is provided
        const normalizedLoginId = normalizeLoginIdentifier(loginIdValue);
        const matchedLogin = normalizedLoginId ? companyLoginLookup[normalizedLoginId] : null;

        // Check if provided UserID exists in database
        if (!matchedLogin) {
          // UserID provided but not found in database
          mismatchList.push({
            row: record.__rowNumber || record.rowNumber || "-",
            loginId: loginIdValue,
            error: `not found in database Company Login`,
          });
        }
      }
    });

    setUserIdMismatchRows(mismatchList);

    // Don't block with toast error - just collect errors for display
    // if (mismatchList.length > 0) {
    //   ToastError(
    //     `User ID validation failed: Some User IDs are not found in Company Login database.`
    //   );
    //   return false;
    // }

    return true;
  };

  const validateVehicleFuelTypes = (records) => {
    if (!records || !records.length) {
      setVehicleFuelValidationErrors([]);
      return true;
    }

    const errorList = [];
    records.forEach((record) => {
      const warnings = record.__warnings || [];
      const vehicleFuelWarnings = warnings.filter(
        (warning) =>
          (warning.includes("Vehicle Make") && warning.includes("not found in database")) ||
          (warning.includes("Fuel Type") && warning.includes("not found in database"))
      );

      if (vehicleFuelWarnings.length > 0) {
        errorList.push({
          row: record.__rowNumber || record.rowNumber || "-",
          errors: vehicleFuelWarnings,
        });
      }
    });

    setVehicleFuelValidationErrors(errorList);

    // Don't block with toast error - just collect errors for display
    // if (errorList.length > 0) {
    //   ToastError(
    //     `Vehicle Make/Fuel Type validation failed: Some values are not found in database.`
    //   );
    //   return false;
    // }

    return true;
  };

  const validateImportPolicyNumbers = (records) => {
    if (isCreateMode || !records || !records.length) {
      setInvalidPolicyNumbers([]);
      return;
    }
    if (!allowedPolicyNumbers.length) {
      setInvalidPolicyNumbers([]);
      return;
    }

    // Special validation: If there's only 1 unmatched policy, Excel must have exactly 1 row matching that policy
    if (unmatchedPolicies.length === 1) {
      const unmatchedPolicy = unmatchedPolicies[0];
      const expectedPolicyNumber = normalizePolicyNumberValue(unmatchedPolicy?.policyNumber || "");

      if (records.length !== 1) {
        setInvalidPolicyNumbers([{
          row: "All",
          policyNumber: "",
          error: `Only 1 unmatched policy exists. Excel file must contain exactly 1 row, but found ${records.length} rows.`,
        }]);
        ToastError(
          `Only 1 unmatched policy exists. Please upload an Excel file with exactly 1 row matching policy number: ${unmatchedPolicy?.policyNumber || ""}`
        );
        return;
      }

      const record = records[0];
      const extractedValues =
        record.__extracted ||
        (record && typeof record === "object" ? record : {});
      const policyNumberValue =
        extractedValues?.policyNumber ||
        record.policyNumber ||
        record.policy_number ||
        "";
      const normalizedPolicyNumber = normalizePolicyNumberValue(policyNumberValue);

      if (!normalizedPolicyNumber || normalizedPolicyNumber !== expectedPolicyNumber) {
        setInvalidPolicyNumbers([{
          row: record.__rowNumber || record.rowNumber || "-",
          policyNumber: policyNumberValue || "",
          error: `Policy number must match the unmatched policy: ${unmatchedPolicy?.policyNumber || ""}`,
        }]);
        ToastError(
          `Only 1 unmatched policy exists. The Excel file must contain exactly 1 row with policy number: ${unmatchedPolicy?.policyNumber || ""}`
        );
        return;
      }

      // Validation passed for single unmatched policy
      setInvalidPolicyNumbers([]);
      return;
    }

    // Normal validation for multiple unmatched policies
    const allowedSet = new Set(
      allowedPolicyNumbers
        .map((num) => normalizePolicyNumberValue(num))
        .filter((num) => !!num)
    );
    const invalidList = [];
    records.forEach((record) => {
      const extractedValues =
        record.__extracted ||
        (record && typeof record === "object" ? record : {});
      const policyNumberValue =
        extractedValues?.policyNumber ||
        record.policyNumber ||
        record.policy_number ||
        "";
      const normalizedPolicyNumber = normalizePolicyNumberValue(policyNumberValue);
      if (!normalizedPolicyNumber || !allowedSet.has(normalizedPolicyNumber)) {
        invalidList.push({
          row: record.__rowNumber || record.rowNumber || "-",
          policyNumber: policyNumberValue || "",
        });
      }
    });

    setInvalidPolicyNumbers(invalidList);
    if (invalidList.length) {
      ToastError(
        "Some policy numbers are not part of the selected bulk upload. Please remove the extra rows and try again."
      );
    }
  };

  const extractCellValue = (value) => {
    if (value === undefined || value === null) return "";
    if (value instanceof Date) return value;
    if (typeof value === "number" || typeof value === "boolean") return value;

    if (typeof value === "object") {
      if (Array.isArray(value.richText)) {
        return value.richText.map((part) => part.text || "").join("");
      }

      if (value.text) {
        return value.text;
      }

      if (value.result !== undefined && value.result !== null) {
        return extractCellValue(value.result);
      }

      if (value.formattedText) {
        return extractCellValue(value.formattedText);
      }

      if (value.hyperlink && value.text) {
        return value.text;
      }

      if (typeof value.values === "function") {
        const evaluated = value.values();
        if (Array.isArray(evaluated) && evaluated.length) {
          return extractCellValue(evaluated[0]);
        }
      }

      if (Array.isArray(value)) {
        return value.map((entry) => extractCellValue(entry)).join("");
      }

      if (value.toString && value.toString() !== "[object Object]") {
        return value.toString();
      }

      return "";
    }

    return value;
  };

  const getRecordValue = (record, keys, defaultValue = "") => {
    for (const key of keys) {
      const normalizedKey = normalizeHeader(key);
      if (
        record[normalizedKey] !== undefined &&
        record[normalizedKey] !== null &&
        record[normalizedKey] !== ""
      ) {
        return record[normalizedKey];
      }

      if (
        record[key] !== undefined &&
        record[key] !== null &&
        record[key] !== ""
      ) {
        return record[key];
      }
    }
    return defaultValue;
  };

  const isValueEmpty = (value) => {
    if (value === undefined || value === null) return true;
    if (typeof value === "string" && value.trim() === "") return true;
    // Check for invalid Date objects
    if (value instanceof Date && (isNaN(value.getTime()) || !isFinite(value.getTime()))) return true;
    return false;
  };

  const mapBulkRecord = (record, selectedCompany = null) => {
    const values = {};
    const missing = [];
    const warnings = [];

    BULK_FIELD_MAPPINGS.forEach((mapping) => {
      const rawValue = getRecordValue(record, mapping.keys, "");
      let transformedValue;

      // For fields with transforms (like dates), always try to transform
      // This ensures we catch invalid dates even if the raw value appears non-empty
      if (mapping.transform) {
        transformedValue = mapping.transform(rawValue);
      } else {
        transformedValue = rawValue;
      }

      if (mapping.formKey === "make" || mapping.formKey === "fuelType" || mapping.formKey === "loginIdFull") {
        if (typeof transformedValue === "string") {
          transformedValue = transformedValue.trim();
        }
      }

      // Strip leading apostrophe from policyNumber (Excel adds this for long numbers)
      if (mapping.formKey === "policyNumber") {
        if (typeof transformedValue === "string") {
          transformedValue = transformedValue.trim().replace(/'/g, "");
        } else if (transformedValue !== undefined && transformedValue !== null) {
          transformedValue = String(transformedValue).trim().replace(/'/g, "");
        }
      }

      values[mapping.formKey] = transformedValue;
    });

    // Company-specific required field validation
    if (selectedCompany) {
      const companyKey = getCompanyRequiredFieldsKey(selectedCompany);
      const requiredFields = COMPANY_REQUIRED_FIELDS[companyKey] || [];

      requiredFields.forEach((fieldKey) => {
        if (isValueEmpty(values[fieldKey])) {
          const fieldMapping = BULK_FIELD_MAPPINGS.find((m) => m.formKey === fieldKey);
          if (fieldMapping) {
            missing.push(fieldMapping.label);
          }
        }
      });
    }

    if (!isValueEmpty(values.make) && Object.keys(vehicleMakeLookup).length > 0) {
      const makeValue = typeof values.make === "string" ? values.make : String(values.make);
      const vehicleMakeId = findBestMatch(makeValue, vehicleMakeLookup);
      if (!vehicleMakeId) {
        warnings.push(`Vehicle Make "${makeValue.trim()}" not found in database`);
      }
    }

    if (!isValueEmpty(values.fuelType) && Object.keys(fuelTypeLookup).length > 0) {
      const fuelTypeValue = typeof values.fuelType === "string" ? values.fuelType : String(values.fuelType);
      const fuelTypeId = findBestMatch(fuelTypeValue, fuelTypeLookup);
      if (!fuelTypeId) {
        warnings.push(`Fuel Type "${fuelTypeValue.trim()}" not found in database`);
      }
    }

    // Check for loginIdFull or pospCode based on company
    const companyKey = bulkCompany?.value || bulkCompany?.label?.toLowerCase() || "";
    const isNationalCompany = companyKey === "national";

    if (isNationalCompany) {
      // For National company, check POSP code
      if (!isValueEmpty(values.pospCode) && Object.keys(companyLoginLookup).length > 0) {
        const pospCodeValue = typeof values.pospCode === "string" ? values.pospCode : String(values.pospCode);
        const normalizedPospCode = normalizeLoginIdentifier(pospCodeValue);
        const matchedLogin = normalizedPospCode ? companyLoginLookup[normalizedPospCode] : null;
        if (!matchedLogin) {
          warnings.push(`POSP Code "${pospCodeValue.trim()}" not found in Company Login remarks`);
        }
      }
    } else {
      // For other companies, check UserID
      if (!isValueEmpty(values.loginIdFull) && Object.keys(companyLoginLookup).length > 0) {
        const loginIdValue = typeof values.loginIdFull === "string" ? values.loginIdFull : String(values.loginIdFull);
        const normalizedLoginId = normalizeLoginIdentifier(loginIdValue);
        const matchedLogin = normalizedLoginId ? companyLoginLookup[normalizedLoginId] : null;
        if (!matchedLogin) {
          warnings.push(`User ID "${loginIdValue.trim()}" not found in database Company Login`);
        }
      }
    }

    const missingWithoutPropDate = missing.filter(item => item !== "Prop Date");
    const isBulkUploadfullFill = missingWithoutPropDate.length === 0;
    values.isBulkUploadfullFill = isBulkUploadfullFill;

    return { values, missing, warnings };
  };

  const resolveCompanyDetails = (selectedOption) => {
    if (!selectedOption) return null;
    const companyKey = selectedOption.value || selectedOption.label || selectedOption;
    if (!companyKey) return null;
    const normalizedKey = companyKey.toString().toLowerCase();
    return (
      companyDetails?.find(
        (company) =>
          company?.label?.toLowerCase() === normalizedKey ||
          company?.shortName?.toLowerCase() === normalizedKey ||
          company?.companyName?.toLowerCase() === normalizedKey
      ) || null
    );
  };

  const validateBulkFileName = (fileName, selectedCompany) => {
    if (!selectedCompany || !fileName) {
      return { isValid: false, error: "" };
    }

    const companyName = selectedCompany.label || selectedCompany.value || "";
    if (!companyName) {
      return { isValid: false, error: "" };
    }

    const fileNameWithoutExt = fileName.replace(/\.(xlsx|xls)$/i, "").trim();
    const actualFileName = fileNameWithoutExt.toLowerCase();
    const companyNameLower = companyName.toLowerCase();

    // if (!actualFileName.includes(companyNameLower)) {
    //   return {
    //     isValid: false,
    //     error: `File name must include the company name "${companyName}". Current file: ${fileName}`,
    //   };
    // }

    const otherCompanies = BULK_COMPANY_OPTIONS.filter(
      (company) => company.label.toLowerCase() !== companyNameLower
    );

    // for (const otherCompany of otherCompanies) {
    //   const otherCompanyNameLower = otherCompany.label.toLowerCase();
    //   if (actualFileName.includes(otherCompanyNameLower)) {
    //     return {
    //       isValid: false,
    //       error: `File name cannot contain multiple company names. Selected: "${companyName}", but file also contains "${otherCompany.label}". Please use only "${companyName}" in the file name.`,
    //     };
    //   }
    // }

    return { isValid: true, error: "" };
  };

  const resetBulkState = () => {
    setBulkCompany(null);
    setBulkFileName("");
    setBulkPreview([]);
    setBulkResults(null);
    setBulkProcessing(false);
    setBulkFileNameError("");
    setBulkFileObject(null);
    setImportResults(null);
    setInvalidPolicyNumbers([]);
    setUserIdMismatchRows([]);
    setVehicleFuelValidationErrors([]);
    setShowAllUserIdErrors(false);
    setShowAllInvalidPolicyErrors(false);
    setShowAllVehicleFuelErrors(false);
    setShowAllBulkResultErrors(false);
    setShowAllImportResultErrors(false);
    setIsParsingFile(false);
  };

  // Load company login data only when dialog opens
  useEffect(() => {
    if (!open) return; // Only run when dialog is open

    let isSubscribed = true;
    GetCompanyLogin()
      .then((res) => {
        if (!isSubscribed || !res?.data) return;
        const lookup = {};
        res.data.forEach((item) => {
          const normalizedId = normalizeLoginIdentifier(
            item?.userIdNumber || item?.loginId || item?.loginPortal
          );
          const resolvedCompanyId =
            item?.companyId?._id ||
            (typeof item?.companyId === "string" ? item.companyId : "");
          if (!normalizedId || !resolvedCompanyId) {
            return;
          }

          const loginData = {
            companyId: resolvedCompanyId,
            companyName:
              item?.companyId?.shortName ||
              item?.companyId?.companyName ||
              "",
            userId:
              item?.userId?._id ||
              (typeof item?.userId === "string" ? item.userId : ""),
            bookingCodeId:
              item?.bookingCodeId?._id ||
              (typeof item?.bookingCodeId === "string"
                ? item?.bookingCodeId
                : ""),
            subBookingCodeId:
              item?.subBookingCodeId?._id ||
              (typeof item?.subBookingCodeId === "string"
                ? item?.subBookingCodeId
                : ""),
            bookingCode:
              item?.bookingCodeId?.bookingCode || item?.bookingCode || "",
            subBookingCode:
              item?.subBookingCodeId?.subBookingCode ||
              item?.subBookingCode ||
              "",
          };

          // Index by UserID/LoginID
          lookup[normalizedId] = loginData;

          // Also index by POSP code if found in remarks (for National company)
          if (item?.remarks) {
            // Convert remarks to string and trim
            const remarksStr = String(item.remarks).trim();
            // Remove surrounding quotes if present
            const cleanRemarks = remarksStr.replace(/^["']|["']$/g, '');

            // Extract all number sequences and use the longest one (likely the POSP code)
            const numberMatches = cleanRemarks.match(/\d+/g);
            if (numberMatches && numberMatches.length > 0) {
              // Use the longest number sequence as POSP code
              const pospCodeRaw = numberMatches.reduce((a, b) => a.length > b.length ? a : b);
              const pospCode = normalizeLoginIdentifier(pospCodeRaw);
              if (pospCode) {
                lookup[pospCode] = loginData;
                // console.log(`Indexed POSP code: ${pospCode} from remarks: "${remarksStr}"`);
              }
            }
          }
        });
        setCompanyLoginLookup(lookup);
      })
      .catch((error) => {
        console.error("Failed to load company login lookup", error);
      });

    return () => {
      isSubscribed = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]); // Run when dialog opens

  // Load fuel type data only when dialog opens
  useEffect(() => {
    if (!open) return; // Only run when dialog is open

    let isSubscribed = true;
    GetFuelType()
      .then((res) => {
        if (!isSubscribed || !res?.data) return;
        const lookup = {};
        res.data.forEach((item) => {
          if (item?.fuelType && item?._id) {
            // Store with basic lowercase normalization
            const basicNormalized = item.fuelType.trim().toLowerCase();
            lookup[basicNormalized] = item._id;

            // Also store with full normalization for better matching
            const fullyNormalized = normalizeVehicleMakeOrFuelType(item.fuelType);
            if (fullyNormalized && fullyNormalized !== basicNormalized) {
              lookup[fullyNormalized] = item._id;
            }
          }
        });
        setFuelTypeLookup(lookup);
      })
      .catch((error) => {
        console.error("Failed to load fuel type lookup", error);
      });

    return () => {
      isSubscribed = false;
    };
  }, [open]); // Run when dialog opens

  // Load vehicle make data only when dialog opens
  useEffect(() => {
    if (!open) return; // Only run when dialog is open
    
    let isSubscribed = true;
    GetVehicleMake({ isAscending: true })
      .then((res) => {
        if (!isSubscribed || !res?.data) return;
        const lookup = {};
        // console.log("=== Building Vehicle Make Lookup ===");
        res.data.forEach((item) => {
          if (item?.vehicleMake && item?._id) {
            // Store with basic lowercase normalization
            const basicNormalized = item.vehicleMake.trim().toLowerCase();
            lookup[basicNormalized] = item._id;

            // Also store with full normalization for better matching
            const fullyNormalized = normalizeVehicleMakeOrFuelType(item.vehicleMake);
            if (fullyNormalized && fullyNormalized !== basicNormalized) {
              lookup[fullyNormalized] = item._id;
            }

            // Debug logging for HERO MOTOR specifically
            // if (item.vehicleMake.toUpperCase().includes("HERO")) {
            //   console.log(`Found HERO vehicle make:`, {
            //     original: `"${item.vehicleMake}"`,
            //     basicNormalized: `"${basicNormalized}"`,
            //     fullyNormalized: `"${fullyNormalized}"`,
            //     length: item.vehicleMake.length,
            //     hasTrailingSpace: item.vehicleMake !== item.vehicleMake.trim(),
            //     id: item._id
            //   });
            // }
          }
        });
        // console.log(`Total vehicle makes loaded: ${Object.keys(lookup).length}`);
        // console.log("Available vehicle makes (first 10):", Object.keys(lookup).slice(0, 10));
        setVehicleMakeLookup(lookup);
      })
      .catch((error) => {
        console.error("Failed to load vehicle make lookup", error);
      });

    return () => {
      isSubscribed = false;
    };
  }, [open]); // Run when dialog opens

  useEffect(() => {
    if (!open) {
      resetBulkState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    if (!isCreateMode && bulkPreview.length) {
      validateImportPolicyNumbers(bulkPreview);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allowedPolicyNumbers, unmatchedPolicies]);

  // Helper function to determine file type
  const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toLowerCase();
  };

  // Parse Excel file using appropriate library based on file extension
  const parseExcelFile = async (file, selectedCompany = null) => {
    setIsParsingFile(true);
    const fileExtension = getFileExtension(file.name);

    try {
      // console.log(`Parsing ${fileExtension.toUpperCase()} file: ${file.name} (${(file.size / 1024 / 1024).toFixed(2)} MB)`);

      let worksheet = null;
      let isXlsxFormat = false;

      if (fileExtension === 'xlsx') {
        // Optimized ExcelJS parsing for .xlsx files
        // console.log("Using optimized ExcelJS for .xlsx file");
        const workbook = new ExcelJS.Workbook();
        const arrayBuffer = await file.arrayBuffer();

        // Use streaming read for better performance with large files
        await workbook.xlsx.load(arrayBuffer, {
          sharedStrings: 'cache', // Cache shared strings for better performance
          hyperlinks: 'ignore',   // Ignore hyperlinks to speed up parsing
          styles: 'ignore'        // Ignore styles to speed up parsing
        });

        worksheet = workbook.worksheets[0];
        isXlsxFormat = true;
      } else if (fileExtension === 'xls') {
        // Use XLSX library for .xls files (already fast)
        // console.log("Using XLSX library for .xls file");
        const arrayBuffer = await file.arrayBuffer();
        const workbook = XLSX.read(arrayBuffer, {
          type: 'array',
          cellStyles: false,  // Skip styles for better performance
          cellHTML: false,    // Skip HTML for better performance
          cellFormula: false  // Skip formulas for better performance
        });
        const sheetName = workbook.SheetNames[0];
        if (!sheetName) {
          setIsParsingFile(false);
          ToastError("Unable to find data sheet in the uploaded file.");
          return null;
        }
        worksheet = workbook.Sheets[sheetName];
        isXlsxFormat = false;
      } else {
        setIsParsingFile(false);
        ToastError("Unsupported file format. Please upload .xlsx or .xls files only.");
        return null;
      }

      if (!worksheet) {
        setIsParsingFile(false);
        ToastError("Unable to find data sheet in the uploaded file.");
        return null;
      }

      // Collect all possible valid header keys from mappings
      const validHeaderKeys = new Set();
      BULK_FIELD_MAPPINGS.forEach(mapping => {
        mapping.keys.forEach(key => validHeaderKeys.add(key));
      });

      let headerRow = null;
      let headerRowIndex = -1;
      let headers = [];
      let maxMatchCount = 0;

      // Get worksheet row count and optimize data access
      let totalRows = 0;
      let worksheetData = null;

      if (isXlsxFormat) {
        totalRows = worksheet.rowCount;
        // Pre-convert ExcelJS worksheet to array for faster access
        // console.log("Converting ExcelJS worksheet to array for faster processing...");
        worksheetData = [];
        worksheet.eachRow((row, rowNumber) => {
          worksheetData[rowNumber] = row.values;
        });
      } else {
        // For XLSX library, get range and calculate row count
        const range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1:A1');
        totalRows = range.e.r + 1; // +1 because range is 0-based
        // Convert XLSX sheet to array for consistent access
        // console.log("Converting XLSX sheet to array for faster processing...");
        worksheetData = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          raw: true,
          defval: undefined
        });
      }

      // Optimized row data access
      const getRowData = (rowNumber) => {
        if (isXlsxFormat) {
          return worksheetData[rowNumber] || [];
        } else {
          return worksheetData[rowNumber - 1] || []; // -1 because XLSX array is 0-based but we use 1-based indexing
        }
      };

      // Scan the first 10 rows to find the best header match
      const maxScanRows = Math.min(10, totalRows);
      let firstRowIsValid = false;

      // console.log(`Total rows in worksheet: ${totalRows}, scanning first ${maxScanRows} rows`);

      for (let r = 1; r <= maxScanRows; r++) {
        const rowValues = getRowData(r);

        // Skip completely empty rows
        if (!rowValues || rowValues.length <= 1) {
          // console.log(`Row ${r}: Skipping empty row`);
          continue;
        }

        // Check if this row contains metadata patterns (especially for first row)
        const rowText = rowValues.slice(1).map(cell => {
          const cellValue = extractCellValue(cell);
          return typeof cellValue === 'string' ? cellValue.toLowerCase() : String(cellValue || '').toLowerCase();
        }).join(' ');

        // Skip rows that contain metadata patterns
        const isMetadataRow = rowText.includes('from date:') ||
          rowText.includes('to date:') ||
          rowText.includes('date range:') ||
          rowText.includes('report period:') ||
          rowText.includes('generated on:') ||
          rowText.includes('total records:') ||
          rowText.includes('summary:') ||
          rowText.includes('report generated') ||
          rowText.includes('export date') ||
          rowText.includes('total premium amount') ||
          rowText.includes('total premium amount (rs.)') ||
          /^\s*from\s*date.*to\s*date/i.test(rowText) ||
          /^\s*date\s*range/i.test(rowText) ||
          /^\s*period:/i.test(rowText);

        if (isMetadataRow) {
          // console.log(`Row ${r}: Skipping metadata row - "${rowText.substring(0, 50)}..."`);
          if (r === 1) {
            console.log("First row contains metadata, will search for headers in subsequent rows");
          }
          continue;
        }

        // Normalize values in this row
        // row.values is 1-based for ExcelJS, 0-based for XLSX library
        const currentHeaders = [];
        let matchCount = 0;
        let totalNonEmptyColumns = 0;

        // Handle different array structures
        const startIndex = isXlsxFormat ? 1 : 0; // ExcelJS is 1-based, XLSX is 0-based
        const valuesLength = rowValues.length;
        const limit = valuesLength;

        for (let c = startIndex; c < limit; c++) {
          const val = normalizeHeader(rowValues[c]);
          currentHeaders.push(val);
          if (val && val.trim() !== '') {
            totalNonEmptyColumns++;
            if (validHeaderKeys.has(val)) {
              matchCount++;
            }
          }
        }

        // console.log(`Row ${r}: Found ${matchCount} valid headers out of ${totalNonEmptyColumns} non-empty columns`);

        // Enhanced validation for header rows
        // A valid header row should have at least 2 matches and reasonable ratio
        const matchRatio = totalNonEmptyColumns > 0 ? matchCount / totalNonEmptyColumns : 0;
        const isValidHeaderRow = matchCount >= 2 && matchRatio >= 0.15 && totalNonEmptyColumns >= 2; // Reduced ratio to 15% for more flexibility

        if (r === 1) {
          firstRowIsValid = isValidHeaderRow;
          // console.log(`First row validation: ${firstRowIsValid ? 'VALID' : 'INVALID'} header (${matchCount} matches, ${(matchRatio * 100).toFixed(1)}% ratio)`);
        }

        // Accept any valid header row, regardless of position
        if (isValidHeaderRow) {
          // console.log(`Row ${r}: Valid header row detected (${matchCount} matches, ${(matchRatio * 100).toFixed(1)}% ratio)`);

          // Always update if this row has more matches than previous best
          if (matchCount > maxMatchCount) {
            maxMatchCount = matchCount;
            headerRow = isXlsxFormat ? worksheet.getRow(r) : null; // Store row for ExcelJS, null for XLSX
            headerRowIndex = r;
            headers = currentHeaders;
            // console.log(`Row ${r}: New best header match found (${matchCount} matches) - Selected as header row`);
          }
        } else {
          console.log(`Row ${r}: Not a valid header row (${matchCount} matches, ${(matchRatio * 100).toFixed(1)}% ratio)`);
        }
      }
      // console.log("=== Header Detection Results ===");
      // console.log("First row was valid header:", firstRowIsValid);
      // console.log("Header found at row:", headerRowIndex);
      // console.log("Headers:", headers.slice(0, 10), "..."); // Show first 10 headers
      // console.log("Max Match Count:", maxMatchCount);
      // console.log("================================");

      if (headerRowIndex === -1 || maxMatchCount < 2) {
        let errorMessage = "Could not identify a valid header row in the uploaded file.";
        if (!firstRowIsValid) {
          errorMessage += " The first row appears to contain metadata or invalid headers.";
        }
        errorMessage += ` Scanned ${maxScanRows} rows, best match had ${maxMatchCount} valid headers.`;
        ToastError(errorMessage);
        return null;
      }

      // console.log(`✅ Successfully identified header row at line ${headerRowIndex} with ${maxMatchCount} matching fields`);
      // console.log(`Will process data starting from row ${headerRowIndex + 1}`);

      const records = [];
      let processedDataRows = 0;
      let skippedRows = 0;

      // console.log(`Processing data rows starting from row ${headerRowIndex + 1}...`);

      // Process data rows using optimized approach
      for (let rowNumber = headerRowIndex + 1; rowNumber <= totalRows; rowNumber++) {
        const values = getRowData(rowNumber);

        if (!values || values.length === 0) {
          // console.log(`Row ${rowNumber}: Empty row - skipping`);
          skippedRows++;
          continue;
        }

        const record = {};
        const startIndex = isXlsxFormat ? 1 : 0; // ExcelJS is 1-based, XLSX is 0-based

        headers.forEach((headerKey, index) => {
          if (!headerKey) return;
          const cellValue = extractCellValue(values[index + startIndex] ?? "");
          if (typeof cellValue === "string") {
            record[headerKey] = cellValue.trim();
          } else {
            record[headerKey] = cellValue;
          }
        });

        const hasContent = Object.values(record).some(
          (val) => val !== undefined && val !== null && val !== ""
        );

        if (!hasContent) {
          // console.log(`Row ${rowNumber}: Empty row - skipping`);
          skippedRows++;
          continue;
        }

        // Additional check to skip rows that might be metadata even after headers
        const rowText = Object.values(record).join(' ').toLowerCase();
        const isMetadataRow = rowText.includes('from date:') ||
          rowText.includes('to date:') ||
          rowText.includes('total:') ||
          rowText.includes('summary:') ||
          rowText.includes('grand total') ||
          rowText.includes('report total') ||
          rowText.includes('total premium amount') ||
          rowText.includes('total premium amount (rs.)') ||
          /^\s*from\s*date.*to\s*date/i.test(rowText) ||
          /^\s*total\s*:/i.test(rowText);

        if (isMetadataRow) {
          // console.log(`Row ${rowNumber}: Metadata row detected - skipping`);
          skippedRows++;
          continue;
        }

        // This is a valid data row
        record.__rowNumber = rowNumber;
        const mapped = mapBulkRecord(record, selectedCompany);
        record.__extracted = mapped.values;
        record.__missingFields = mapped.missing;
        record.__warnings = mapped.warnings || [];
        records.push(record);
        processedDataRows++;

        // console.log(`Row ${rowNumber}: Valid data row processed`);
      }

      // console.log(`=== Data Processing Summary ===`);
      // console.log(`Header found at row: ${headerRowIndex}`);
      // console.log(`Valid data rows processed: ${processedDataRows}`);
      // console.log(`Rows skipped: ${skippedRows}`);
      // console.log(`Total records created: ${records.length}`);
      // console.log(`===============================`);

      if (!records.length) {
        setIsParsingFile(false);
        ToastError("No data rows identified in the uploaded Excel file.");
        return null;
      }

      setIsParsingFile(false);
      // console.log(`✅ File parsing completed successfully in ${fileExtension.toUpperCase()} format`);
      return records;
    } catch (error) {
      setIsParsingFile(false);
      console.error("Bulk upload parse error:", error);
      ToastError(`Unable to read the uploaded ${fileExtension?.toUpperCase() || 'Excel'} file. ${error.message || ''}`);
      return null;
    }
  };

  const handleBulkDialogClose = () => {
    if (bulkProcessing || isParsingFile) return;
    resetBulkState();
    if (onClose) {
      onClose();
    }
  };

  const handleBulkFileChange = async (input) => {
    const file =
      input instanceof File
        ? input
        : input?.target?.files?.[0] || null;

    if (input?.target) {
      input.target.value = "";
    }

    setBulkResults(null);
    setImportResults(null);
    setBulkPreview([]);
    setBulkFileName("");
    setBulkFileNameError("");
    setUserIdMismatchRows([]);
    setVehicleFuelValidationErrors([]);
    setShowAllUserIdErrors(false);
    setShowAllInvalidPolicyErrors(false);
    setShowAllVehicleFuelErrors(false);
    setShowAllBulkResultErrors(false);
    setShowAllImportResultErrors(false);

    if (!file) {
      return;
    }

    setBulkFileObject(file);
    setBulkFileName(file.name);

    if (isCreateMode) {
      if (!bulkCompany) {
        ToastError("Please select a company before uploading the Excel file.");
        setBulkFileNameError("Company selection is required before uploading file.");
        return;
      }

      const validation = validateBulkFileName(file.name, bulkCompany);
      if (!validation.isValid) {
        setBulkFileNameError(validation.error);
        ToastError(validation.error);
        return;
      }
      setBulkFileNameError("");
    }

    const records = await parseExcelFile(file, bulkCompany);
    if (records) {
      setBulkPreview(records);
      validateUserIdMatch(records, bulkCompany);
      validateVehicleFuelTypes(records);
      if (!isCreateMode) {
        validateImportPolicyNumbers(records);
      }
    } else {
      setBulkFileName("");
      setBulkFileObject(null);
      setInvalidPolicyNumbers([]);
      setUserIdMismatchRows([]);
      setVehicleFuelValidationErrors([]);
    }
  };

  const handleCreateSubmit = async () => {
    if (!bulkCompany) {
      ToastError("Please select a company before processing.");
      return;
    }

    if (!bulkPreview.length) {
      ToastError("Please upload an Excel file with policy data.");
      return;
    }

    const companyInfo = resolveCompanyDetails(bulkCompany);
    if (!companyInfo) {
      ToastError(
        "Selected company is not available. Please add it to the master before proceeding."
      );
      return;
    }

    const companyIdForBulk =
      companyInfo?.value || companyInfo?._id || companyInfo?.id || "";

    setBulkProcessing(true);
    setOpenLoader?.(true);

    // Collect all validation errors from the preview
    const allValidationErrors = [];
    let skippedCount = 0;

    bulkPreview.forEach((record) => {
      const warnings = record.__warnings || [];
      const rowNumber = record.__rowNumber || record.rowNumber || "-";

      warnings.forEach((warning) => {
        allValidationErrors.push({
          row: rowNumber,
          field: warning.includes("User ID") ? "User ID" :
            warning.includes("POSP Code") ? "POSP Code" :
              warning.includes("Vehicle Make") ? "Vehicle Make" : "Fuel Type",
          value: "",
          error: warning
        });
      });

      if (warnings.length > 0) {
        skippedCount++;
      }
    });

    let bulkUploadExcelFileId = null;
    if (bulkFileObject) {
      try {
        console.log("=== Starting bulk upload Excel file save ===");
        const UserName = sessionStorage.getItem("UserId");
        const formData = new FormData();
        formData.append("excelFile", bulkFileObject);
        formData.append("companyName", bulkCompany.label || bulkCompany.value || "");
        formData.append("createdBy", UserName || "");

        // Add validation errors to the form data
        if (allValidationErrors.length > 0) {
          console.log("Adding validation errors:", allValidationErrors.length);
          formData.append("validationErrors", JSON.stringify(allValidationErrors));
          formData.append("skippedRecords", skippedCount.toString());
        }

        console.log("Calling PostBulkUploadExcelFile...");
        const uploadResponse = await PostBulkUploadExcelFile(formData);
        console.log("Upload response:", uploadResponse);

        if (uploadResponse?.error) {
          console.error("Upload failed with error:", uploadResponse);
          setBulkProcessing(false);
          setOpenLoader?.(false);
          return;
        }
        bulkUploadExcelFileId = uploadResponse?.data?._id || uploadResponse?._id;
        console.log("Bulk upload Excel file saved with ID:", bulkUploadExcelFileId);
      } catch (error) {
        console.error("Failed to upload Excel file:", error);
        ToastError("Failed to upload Excel file. Please try again.");
        setBulkProcessing(false);
        setOpenLoader?.(false);
        return;
      }
    }

    const validPolicies = [];
    const results = { success: 0, failed: 0, skipped: 0, errors: [] };

    for (const record of bulkPreview) {
      const mapped =
        record.__extracted && record.__missingFields
          ? { values: record.__extracted, missing: record.__missingFields, warnings: record.__warnings || [] }
          : mapBulkRecord(record, bulkCompany);

      const extractedValues = mapped.values;
      const policyNumberValue = extractedValues.policyNumber;
      const warnings = mapped.warnings || record.__warnings || [];

      // Skip rows with validation errors (User ID, POSP Code, Vehicle Make, Fuel Type)
      if (warnings.length > 0) {
        results.skipped += 1;
        results.errors.push({
          row: record.__rowNumber,
          message: "Skipped due to validation errors: " + warnings.join(", "),
        });
        continue;
      }

      if (!policyNumberValue) {
        results.failed += 1;
        results.errors.push({
          row: record.__rowNumber,
          message: "Policy number is missing.",
        });
        continue;
      }

      const policyData = {};
      policyData.__rowNumber = record.__rowNumber; // Track row number for error reporting

      // Remove leading apostrophe (') from policy number if present
      let cleanPolicyNumber = policyNumberValue.toString().trim();
      if (cleanPolicyNumber.startsWith("'")) {
        cleanPolicyNumber = cleanPolicyNumber.substring(1);
      }
      policyData.policyNumber = cleanPolicyNumber;
      policyData.issueDate = extractedValues.issueDate || new Date();

      // Calculate totalPremium for National company if not provided
      let totalPremiumValue = extractedValues.totalPremium;
      if (isValueEmpty(totalPremiumValue)) {
        const companyKey = bulkCompany?.value || bulkCompany?.label?.toLowerCase() || "";
        if (companyKey === "national") {
          const odPremiumStr = extractedValues.odPremium?.toString().replace(/,/g, "") || "0";
          const tpPremiumStr = extractedValues.tpPremium?.toString().replace(/,/g, "") || "0";
          const odPremium = parseFloat(odPremiumStr) || 0;
          const tpPremium = parseFloat(tpPremiumStr) || 0;
          if (odPremium > 0 || tpPremium > 0) {
            totalPremiumValue = (odPremium + tpPremium).toString();
          }
        }
      }

      if (!isValueEmpty(totalPremiumValue)) {
        policyData.totalPremium = parseFloat(parseFloat(totalPremiumValue).toFixed(0));
      }

      // Determine which identifier to use based on company
      const companyKey = bulkCompany?.value || bulkCompany?.label?.toLowerCase() || "";
      const isNationalCompany = companyKey === "national";

      let matchedLogin = null;
      if (isNationalCompany) {
        // For National company, use POSP code
        const normalizedPospCode = normalizeLoginIdentifier(extractedValues.pospCode);
        matchedLogin = normalizedPospCode ? companyLoginLookup[normalizedPospCode] : null;
        // console.log(`Policy ${cleanPolicyNumber}: POSP code "${extractedValues.pospCode}" -> normalized: "${normalizedPospCode}" -> matched:`, matchedLogin ? 'YES' : 'NO');
      } else {
        // For other companies (Reliance, United), use UserID
        const normalizedLoginId = normalizeLoginIdentifier(extractedValues.loginIdFull);
        matchedLogin = normalizedLoginId ? companyLoginLookup[normalizedLoginId] : null;
      }

      if (matchedLogin?.userId) {
        policyData.userId = matchedLogin.userId;
      }

      const companyIdFromLogin = matchedLogin?.companyId || "";
      const companyIdToUse = companyIdFromLogin || companyIdForBulk;

      if (!companyIdToUse) {
        results.failed += 1;
        results.errors.push({
          row: record.__rowNumber,
          message:
            "Company could not be determined for the provided Login ID/User ID.",
        });
        continue;
      }

      policyData.companyId = companyIdToUse;
      policyData.paymentMode = DEFAULT_PAYMENT_MODE;
      policyData.policyPortal = DEFAULT_POLICY_PORTAL;
      policyData.source = "ONLINE";

      if (matchedLogin?.companyId) {
        const loginPayload = {
          companyId: matchedLogin.companyId,
        };
        if (matchedLogin?.userId) {
          loginPayload.userId = matchedLogin.userId;
        }
        if (matchedLogin?.bookingCodeId) {
          loginPayload.bookingCodeId = matchedLogin.bookingCodeId;
          policyData.bookingCodeId = matchedLogin.bookingCodeId;
        }
        if (matchedLogin?.subBookingCodeId) {
          loginPayload.subBookingCodeId = matchedLogin.subBookingCodeId;
          policyData.subBookingCodeId = matchedLogin.subBookingCodeId;
        }
        if (matchedLogin?.bookingCode) {
          policyData.bookingCode = matchedLogin.bookingCode;
        }
        if (matchedLogin?.subBookingCode) {
          policyData.subBookingCode = matchedLogin.subBookingCode;
        }
        policyData.loginId = JSON.stringify(loginPayload);
      }

      if (!isValueEmpty(extractedValues.registrationNumber)) {
        policyData.registrationNumber = extractedValues.registrationNumber;
      }
      if (!isValueEmpty(extractedValues.customerName)) {
        policyData.customerName = extractedValues.customerName;
      }
      if (!isValueEmpty(extractedValues.model)) {
        policyData.model = extractedValues.model;
      }
      if (!isValueEmpty(extractedValues.pospCode)) {
        policyData.pospCode = extractedValues.pospCode;
      }
      if (!isValueEmpty(extractedValues.registrationYear)) {
        policyData.registrationYear = extractedValues.registrationYear;
      }
      if (!isValueEmpty(extractedValues.odDisc)) {
        policyData.odDisc = parseFloat(extractedValues.odDisc).toFixed(0);
      }
      if (!isValueEmpty(extractedValues.odPremium)) {
        const odPremium = parseFloat(extractedValues.odPremium) || 0;
        const addOnPremium = parseFloat(extractedValues.addOnPremium) || 0;
        const totalPremium = odPremium + addOnPremium;
        policyData.odPremium = parseFloat(totalPremium.toFixed(0));
      }
      if (!isValueEmpty(extractedValues.tpPremium)) {
        policyData.tpPremium = parseFloat(parseFloat(extractedValues.tpPremium).toFixed(0));
      }
      // Calculate Net Premium (OD Premium + TP Premium) if both values are provided
      if (!isValueEmpty(extractedValues.odPremium) && !isValueEmpty(extractedValues.tpPremium)) {
        const odPremium = parseFloat(extractedValues.odPremium) || 0;
        const tpPremium = parseFloat(extractedValues.tpPremium) || 0;
        const addOnPremium = parseFloat(extractedValues.addOnPremium) || 0;
        const totalPremium = odPremium + tpPremium + addOnPremium;
        policyData.netPremium = parseFloat(totalPremium.toFixed(0));
      }
      if (!isValueEmpty(extractedValues.cc)) {
        policyData.cc = extractedValues.cc;
      }
      if (!isValueEmpty(extractedValues.seatingCapacity)) {
        policyData.seatingCapacity = extractedValues.seatingCapacity;
      }

      if (!isValueEmpty(extractedValues.loginIdFull)) {
        policyData.loginIdFull = extractedValues.loginIdFull;
      }

      if (!isValueEmpty(extractedValues.mobileNumber)) {
        policyData.mobileNumber = extractedValues.mobileNumber;
      }

      if (!isValueEmpty(extractedValues.gvw)) {
        policyData.gvw = parseFloat(parseFloat(extractedValues.gvw).toFixed(0));
      }

      if (!isValueEmpty(extractedValues.idv)) {
        policyData.idv = parseFloat(parseFloat(extractedValues.idv).toFixed(0));
      }
      if (!isValueEmpty(extractedValues.premium)) {
        policyData.premium = parseFloat(parseFloat(extractedValues.premium).toFixed(0));
      }

      if (!isValueEmpty(extractedValues.fuelType)) {
        const fuelTypeValue =
          typeof extractedValues.fuelType === "string"
            ? extractedValues.fuelType
            : String(extractedValues.fuelType);
        const fuelTypeId = findBestMatch(fuelTypeValue, fuelTypeLookup);
        if (fuelTypeId) {
          policyData.fuelType = fuelTypeId;
        } else {
          console.warn(
            `Fuel type "${fuelTypeValue.trim()}" not found in lookup for row ${record.__rowNumber}`
          );
        }
      }

      // if (!isValueEmpty(extractedValues.make)) {
      //   const makeValue =
      //     typeof extractedValues.make === "string"
      //       ? extractedValues.make
      //       : String(extractedValues.make);
      //   const vehicleMakeId = findBestMatch(makeValue, vehicleMakeLookup);
      //   if (vehicleMakeId) {
      //     policyData.make = vehicleMakeId;
      //   } else {
      //     console.warn(
      //       `Vehicle make "${makeValue.trim()}" not found in lookup for row ${record.__rowNumber}`
      //     );
      //   }
      // }

      policyData.isBulkUpload = true;
      policyData.isBulkUploadfullFill = extractedValues.isBulkUploadfullFill;
      if (bulkUploadExcelFileId) {
        policyData.BulkUploadExecelFile = bulkUploadExcelFileId;
      }

      validPolicies.push(policyData);
    }

    if (validPolicies.length > 0) {
      try {
        const formData = new FormData();
        formData.append("policies", JSON.stringify(validPolicies));

        const response = await CreateBulkPolicies(formData);

        if (response?.error) {
          results.failed += validPolicies.length;
          results.errors.push({ message: response.message || "Bulk creation failed" });
        } else {
          const data = response.data || {};
          results.success += data.successCount || 0;
          results.failed += data.failureCount || 0;
          if (data.failures && Array.isArray(data.failures)) {
            data.failures.forEach(f => {
              results.errors.push({
                row: f.row,
                message: f.error
              });
            });
          }
        }

      } catch (error) {
        // console.error("Bulk create API error:", error);
        results.failed += validPolicies.length;
        results.errors.push({ message: "Network error or server failure during bulk creation." });
      }
    }

    setBulkResults(results);
    setOpenLoader?.(false);
    setBulkProcessing(false);

    if (bulkUploadExcelFileId && results.success === 0 && results.failed > 0) {
      ToastError(
        `All policies failed to create. Please fix the errors and try again.`
      );
    } else if (results.success > 0) {
      if (bulkUploadExcelFileId) {
        try {
          await UpdateBulkUploadExcelFileTimestamp(bulkUploadExcelFileId);
        } catch (error) {
          console.error("Failed to update bulk upload file timestamp:", error);
        }
      }

      ToastSuccess(`${results.success} policies created successfully.`);
      if (onSuccess) {
        onSuccess();
      }
    }

    if (results.failed > 0 && results.success > 0) {
      ToastError(
        `${results.failed} policies failed to create. Please review the errors.`
      );
    }
    return results;
  };

  const handleImportSubmit = async () => {
    if (!selectedBulkFileId) {
      ToastError("Bulk upload file ID is missing.");
      return;
    }

    if (!bulkFileObject) {
      ToastError("Please upload an Excel file with policy data.");
      return;
    }

    // Validate User ID matches
    // if (userIdMismatchRows.length > 0) {
    //   ToastError("User ID mismatch detected. Please fix the Excel file before submitting.");
    //   return;
    // }

    // Validate Vehicle Make and Fuel Type
    // if (vehicleFuelValidationErrors.length > 0) {
    //   ToastError("Vehicle Make or Fuel Type errors detected. Please fix the Excel file before submitting.");
    //   return;
    // }

    // Check for invalid policy numbers before submitting
    if (invalidPolicyNumbers.length > 0) {
      ToastError("Please fix the invalid policy numbers before submitting.");
      return;
    }

    const hasPolicyNumber = bulkPreview.some((record) => {
      const mapped =
        record.__extracted && record.__missingFields
          ? { values: record.__extracted }
          : mapBulkRecord(record);
      return mapped.values?.policyNumber;
    });

    if (!hasPolicyNumber) {
      ToastError("No policy numbers detected in the uploaded file.");
      return;
    }

    setBulkProcessing(true);
    setOpenLoader?.(true);
    setImportResults(null);

    try {
      const response = await ImportAndUpdateBulkUploadedPolicies(
        selectedBulkFileId,
        bulkFileObject
      );
      setBulkProcessing(false);
      setOpenLoader?.(false);
      if (response?.error) {
        ToastError(response?.message || "Failed to import and update policies");
        return;
      }
      const resultData = response?.data || response;
      setImportResults(resultData);
      ToastSuccess(response?.message || "Policies updated successfully");
      if (onSuccess) {
        onSuccess();
      }
      return resultData;
    } catch (error) {
      setBulkProcessing(false);
      setOpenLoader?.(false);
      // console.error("Error importing file:", error);
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to import and update policies";
      ToastError(message);
    }
  };

  const handleSubmit = async () => {
    if (!bulkPreview.length || !bulkFileObject) {
      ToastError("Please upload an Excel file with policy data.");
      return;
    }

    // Validate User ID matches
    // if (userIdMismatchRows.length > 0) {
    //   ToastError("User ID mismatch detected. Please fix the Excel file before submitting.");
    //   return;
    // }

    // Validate Vehicle Make and Fuel Type
    // if (vehicleFuelValidationErrors.length > 0) {
    //   ToastError("Vehicle Make or Fuel Type errors detected. Please fix the Excel file before submitting.");
    //   return;
    // }

    if (!isCreateMode && invalidPolicyNumbers.length > 0) {
      ToastError("Please remove rows with unknown policy numbers before importing.");
      return;
    }

    if (isCreateMode) {
      const results = await handleCreateSubmit();
      if (results && results?.failed === 0) {
        handleBulkDialogClose();
      }
    } else {
      const results = await handleImportSubmit();
      if (results && results?.errorCount === 0) {
        handleBulkDialogClose();
      }
    }
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleBulkDialogClose}
      fullWidth
      maxWidth="sm"
    >
      <Box p={3} display="flex" flexDirection="column" gap={2}>
        <Typography variant="h6" fontWeight={600}>
          {dialogTitle}
        </Typography>
        {!isCreateMode && (bulkFileName || selectedBulkFileName) && (
          <Typography variant="subtitle2" color="text.secondary">
            Original File: {selectedBulkFileName}
          </Typography>
        )}
        {!isCreateMode && bulkFileName && (
          <Typography variant="subtitle2" color="primary" sx={{ fontWeight: 500 }}>
            Importing: {bulkFileName}
          </Typography>
        )}
        {isCreateMode && (
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "4px",
              backgroundColor: "#fafafa",
            }}
          >
            <Autocomplete
              options={BULK_COMPANY_OPTIONS}
              value={bulkCompany}
              onChange={async (_, value) => {
                setBulkCompany(value);
                if (bulkFileName && value) {
                  const validation = validateBulkFileName(bulkFileName, value);
                  if (!validation.isValid) {
                    setBulkFileNameError(validation.error);
                    ToastError(validation.error);
                    setBulkPreview([]);
                  } else {
                    setBulkFileNameError("");
                    if (bulkFileObject) {
                      const records = await parseExcelFile(bulkFileObject, value);
                      if (records) {
                        setBulkPreview(records);
                        validateUserIdMatch(records, value);
                        validateVehicleFuelTypes(records);
                      }
                    } else if (bulkPreview.length === 0) {
                      ToastError("Please re-upload the Excel file.");
                    }
                  }
                } else {
                  setBulkFileNameError("");
                  if (!value && bulkFileName) {
                    setBulkFileName("");
                    setBulkPreview([]);
                    setBulkFileObject(null);
                  }
                }
              }}
              getOptionLabel={(option) => option?.label ?? ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Company *"
                  required
                  error={!bulkCompany && bulkFileName ? true : false}
                  helperText={
                    !bulkCompany && bulkFileName
                      ? "Company selection is required"
                      : ""
                  }
                />
              )}
            />
          </Box>
        )}
        <Box>
          <Box sx={{ mb: 2 }}>
            <FileUploader
              handleChange={handleBulkFileChange}
              name="excelFile"
              types={["xlsx", "xls"]}
              label="Drag & drop Excel file here or click to browse"
              disabled={bulkProcessing || isParsingFile || (isCreateMode && !bulkCompany)}
            />
            {isParsingFile && (
              <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box
                  sx={{
                    width: 16,
                    height: 16,
                    border: '2px solid #f3f3f3',
                    borderTop: '2px solid #1976d2',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    '@keyframes spin': {
                      '0%': { transform: 'rotate(0deg)' },
                      '100%': { transform: 'rotate(360deg)' }
                    }
                  }}
                />
                <Typography variant="caption" color="primary">
                  Parsing Excel file... Please wait
                </Typography>
              </Box>
            )}
          </Box>
          {isCreateMode && !bulkCompany && (
            <Typography
              variant="caption"
              display="block"
              sx={{ mt: 0.5, color: "error.main", fontSize: "0.75rem" }}
            >
              Please select a company before uploading the Excel file.
            </Typography>
          )}
          {bulkFileName ? (
            <Typography
              variant="caption"
              display="block"
              sx={{
                mt: 1,
                color: bulkFileNameError ? "error.main" : "text.primary",
                fontWeight: bulkFileNameError ? 600 : 400,
              }}
            >
              {bulkFileName}
            </Typography>
          ) : null}
          {bulkFileNameError ? (
            <Typography
              variant="caption"
              display="block"
              sx={{ mt: 0.5, color: "error.main", fontSize: "0.75rem" }}
            >
              {bulkFileNameError}
            </Typography>
          ) : null}
          {!isCreateMode && invalidPolicyNumbers.length > 0 && (
            <Box
              sx={{
                mt: 1,
                p: 1,
                border: "1px solid",
                borderColor: "error.light",
                borderRadius: 1,
                bgcolor: "#fff5f5",
              }}
            >
              <Typography
                variant="caption"
                display="block"
                sx={{ color: "error.main", fontWeight: 600, mb: 0.5 }}
              >
                {invalidPolicyNumbers.length} row
                {invalidPolicyNumbers.length > 1 ? "s" : ""} contain policy numbers
                that do not belong to this bulk upload.
              </Typography>
              {(showAllInvalidPolicyErrors ? invalidPolicyNumbers : invalidPolicyNumbers.slice(0, 5)).map((item, idx) => (
                <Typography key={`${item.policyNumber}-${idx}`} variant="caption" display="block">
                  Row {item.row}: {item.policyNumber || item.error || "(blank)"}
                </Typography>
              ))}
              {invalidPolicyNumbers.length > 5 && (
                <Typography
                  variant="caption"
                  sx={{
                    color: "primary.main",
                    cursor: "pointer",
                    textDecoration: "underline",
                    "&:hover": { color: "primary.dark" }
                  }}
                  onClick={() => setShowAllInvalidPolicyErrors(!showAllInvalidPolicyErrors)}
                >
                  {showAllInvalidPolicyErrors
                    ? "Show less"
                    : `...and ${invalidPolicyNumbers.length - 5} more (click to expand)`}
                </Typography>
              )}
            </Box>
          )}
          {userIdMismatchRows.length > 0 && (
            <Box
              sx={{
                mt: 1,
                p: 1,
                border: "1px solid",
                borderColor: "error.light",
                borderRadius: 1,
                bgcolor: "#fff5f5",
              }}
            >
              <Typography
                variant="caption"
                display="block"
                sx={{ color: "error.main", fontWeight: 600, mb: 0.5 }}
              >
                {userIdMismatchRows.length} row
                {userIdMismatchRows.length > 1 ? "s" : ""} have User ID validation errors.
              </Typography>
              {(showAllUserIdErrors ? userIdMismatchRows : userIdMismatchRows.slice(0, 5)).map((item, idx) => (
                <Typography key={`${item.loginId}-${idx}`} variant="caption" display="block">
                  Row {item.row}: User ID "{item.loginId}" {item.error}
                </Typography>
              ))}
              {userIdMismatchRows.length > 5 && (
                <Typography
                  variant="caption"
                  sx={{
                    color: "primary.main",
                    cursor: "pointer",
                    textDecoration: "underline",
                    "&:hover": { color: "primary.dark" }
                  }}
                  onClick={() => setShowAllUserIdErrors(!showAllUserIdErrors)}
                >
                  {showAllUserIdErrors
                    ? "Show less"
                    : `...and ${userIdMismatchRows.length - 5} more (click to expand)`}
                </Typography>
              )}
            </Box>
          )}
          {vehicleFuelValidationErrors.length > 0 && (
            <Box
              sx={{
                mt: 1,
                p: 1,
                border: "1px solid",
                borderColor: "error.light",
                borderRadius: 1,
                bgcolor: "#fff5f5",
              }}
            >
              <Typography
                variant="caption"
                display="block"
                sx={{ color: "error.main", fontWeight: 600, mb: 0.5 }}
              >
                {vehicleFuelValidationErrors.length} row
                {vehicleFuelValidationErrors.length > 1 ? "s" : ""} have Vehicle Make/Fuel Type errors.
              </Typography>
              {(showAllVehicleFuelErrors ? vehicleFuelValidationErrors : vehicleFuelValidationErrors.slice(0, 5)).map((item, idx) => (
                <Box key={`${item.row}-${idx}`}>
                  <Typography variant="caption" display="block" sx={{ fontWeight: 600 }}>
                    Row {item.row}:
                  </Typography>
                  {item.errors.map((error, errorIdx) => (
                    <Typography key={`${item.row}-error-${errorIdx}`} variant="caption" display="block" sx={{ ml: 1 }}>
                      • {error}
                    </Typography>
                  ))}
                </Box>
              ))}
              {vehicleFuelValidationErrors.length > 5 && (
                <Typography
                  variant="caption"
                  sx={{
                    color: "primary.main",
                    cursor: "pointer",
                    textDecoration: "underline",
                    "&:hover": { color: "primary.dark" }
                  }}
                  onClick={() => setShowAllVehicleFuelErrors(!showAllVehicleFuelErrors)}
                >
                  {showAllVehicleFuelErrors
                    ? "Show less"
                    : `...and ${vehicleFuelValidationErrors.length - 5} more rows (click to expand)`}
                </Typography>
              )}
            </Box>
          )}
        </Box>
        {bulkPreview.length > 0 && (
          <Box>
            <Typography variant="body2" color="text.secondary">
              Detected {bulkPreview.length} row
              {bulkPreview.length > 1 ? "s" : ""}.
            </Typography>
            {bulkCompany && (() => {
              const companyKey = getCompanyRequiredFieldsKey(bulkCompany);
              const requiredFields = COMPANY_REQUIRED_FIELDS[companyKey] || [];
              const fieldLabels = requiredFields
                .map((fieldKey) => {
                  const mapping = BULK_FIELD_MAPPINGS.find((m) => m.formKey === fieldKey);
                  return mapping ? mapping.label : null;
                })
                .filter((label) => label !== null);

              return (
                <Typography variant="body2" color="primary" sx={{ mt: 0.5, fontWeight: 500 }}>
                  <strong>Mandatory fields for {bulkCompany.label}:</strong>{" "}
                  {fieldLabels.join(", ")}
                </Typography>
              );
            })()}
            <BulkUploadPreview rows={bulkPreview} />
          </Box>
        )}
        {bulkResults && (
          <Box>
            <Typography variant="subtitle2" color="success.main">
              Created: {bulkResults.success}
            </Typography>
            <Typography
              variant="subtitle2"
              color={bulkResults.failed ? "error.main" : "text.secondary"}
            >
              Failed: {bulkResults.failed}
            </Typography>
            {!!bulkResults.errors?.length && (
              <Box
                mt={1}
                sx={{
                  bgcolor: "#fff5f5",
                  borderRadius: 1,
                  p: 1,
                }}
              >
                {(showAllBulkResultErrors ? bulkResults.errors : bulkResults.errors.slice(0, 5)).map((item, index) => (
                  <Typography
                    variant="caption"
                    color="error"
                    display="block"
                    key={`${item.row}-${index}`}
                  >
                    Row {item.row}: {item.message}
                  </Typography>
                ))}
                {bulkResults.errors.length > 5 && (
                  <Typography
                    variant="caption"
                    sx={{
                      color: "primary.main",
                      cursor: "pointer",
                      textDecoration: "underline",
                      "&:hover": { color: "primary.dark" }
                    }}
                    onClick={() => setShowAllBulkResultErrors(!showAllBulkResultErrors)}
                  >
                    {showAllBulkResultErrors
                      ? "Show less"
                      : `...and ${bulkResults.errors.length - 5} more errors (click to expand)`}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        )}
        {!isCreateMode && importResults && (
          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Import Results
            </Typography>
            <Typography variant="body2">
              Sheet Name: {importResults.sheetName ?? "-"}
            </Typography>
            <Typography variant="body2">
              Total Rows: {importResults.totalRows ?? 0}
            </Typography>
            <Typography variant="body2" color="success.main">
              Successfully Updated: {importResults.successCount ?? 0}
            </Typography>
            <Typography variant="body2" color="error.main">
              Errors: {importResults.errorCount ?? 0}
            </Typography>
            {Array.isArray(importResults.errors) && importResults.errors.length > 0 && (
              <Box sx={{ mt: 1 }}>
                <Typography variant="subtitle2" color="error.main">
                  Errors:
                </Typography>
                {(showAllImportResultErrors ? importResults.errors : importResults.errors.slice(0, 5)).map((error, idx) => (
                  <Typography key={idx} variant="caption" display="block">
                    Row {error.row}: {error.error}
                  </Typography>
                ))}
                {importResults.errors.length > 5 && (
                  <Typography
                    variant="caption"
                    sx={{
                      color: "primary.main",
                      cursor: "pointer",
                      textDecoration: "underline",
                      "&:hover": { color: "primary.dark" }
                    }}
                    onClick={() => setShowAllImportResultErrors(!showAllImportResultErrors)}
                  >
                    {showAllImportResultErrors
                      ? "Show less"
                      : `...and ${importResults.errors.length - 5} more errors (click to expand)`}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        )}
        <Box display="flex" justifyContent="flex-end" gap={1}>
          <Button onClick={handleBulkDialogClose} disabled={bulkProcessing || isParsingFile}>
            Close
          </Button>
          <Button
            variant="contained"
            startIcon={<CloudUploadIcon />}
            onClick={handleSubmit}
            disabled={
              bulkProcessing ||
              isParsingFile ||
              !bulkPreview.length ||
              (isCreateMode && !bulkCompany) ||
              (!isCreateMode && invalidPolicyNumbers.length > 0)
            }
          >
            {bulkProcessing
              ? isCreateMode
                ? "Processing..."
                : "Importing..."
              : isCreateMode
                ? `Create${bulkPreview.length ? ` (${bulkPreview.length})` : ""}`
                : "Import & Update"}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default BulkUploadDialog;


